<template>
  <div>
    <tabela-padrao-prime-vue
      v-model="tabela.selecionados"
      class="mt-2"
      :colunas="tabela.colunas"
      :dados="tabela.dados"
      :mostrar-acoes="false"
      selecionar-colunas
      :mostrar-seletor="false"
      sem-selecionar-todos
      :quantidade-itens="tabela.quantidadeItens"
      :por-pagina="tabela.porPagina"
      :quantidade-paginas="tabela.quantidadePaginas"
      :pagina="tabela.paginaAtual"
      @paginar="listarRegistros"
    >
      <template v-slot:acao="{ slotProps }">
        <div>
          {{ formatarAcaoPrevisaoEntrega(slotProps.data.acao)?.text }}
        </div>
      </template>
    </tabela-padrao-prime-vue>
  </div>
</template>

<script>
import { OrdemServicoService } from '@/common/services/cadastros';
import helpers from '@/common/utils/helpers';

export default {
  name: 'LogsNegociacao',
  props: {
    id: { type: String, default: null },
  },
  data() {
    return {
      tabela: {
        selecionados: [],
        dados: [],
        colunas: [
          {
            value: 'dataAlteracao',
            text: this.$t(
              'modulos.ordem_servico.formulario.previsao_entrega.tabela.data_hora'
            ),
            formatter: (v) => {
              if (v) return helpers.formatarDataBr(v, true);
            },
          },
          {
            value: 'acao',
            text: this.$t(
              'modulos.ordem_servico.formulario.previsao_entrega.tabela.acao'
            ),
          },
          {
            value: 'dataPrevisaoEntrega',
            text: this.$t(
              'modulos.ordem_servico.formulario.previsao_entrega.tabela.data_previsao_entrega'
            ),
            formatter: (v) => {
              if (v) return helpers.formatarDataBr(v);
            },
          },
          {
            value: 'observacao',
            text: this.$t(
              'modulos.ordem_servico.formulario.previsao_entrega.tabela.observacao'
            ),
          },
          {
            value: 'usuarioNome',
            text: this.$t(
              'modulos.ordem_servico.formulario.previsao_entrega.tabela.usuario'
            ),
          },
          {
            value: 'participanteNome',
            text: this.$t(
              'modulos.ordem_servico.formulario.previsao_entrega.tabela.participante'
            ),
          },
        ],
        quantidadeItens: 0,
        quantidadePaginas: 0,
        paginaAtual: 1,
        porPagina: 10,
      },
      filtroAplicado: { filter: '' },
    };
  },
  mounted() {
    this.listarRegistros();
  },
  methods: {
    formatarAcaoPrevisaoEntrega: function (v) {
      return helpers.PrevisaoEntregaAcaoEnum.find((el) => el.value == v);
    },
    listarRegistros: function (
      paginaAtual = this.tabela.paginaAtual,
      porPagina = this.tabela.porPagina
    ) {
      this.tabela.porPagina = porPagina;
      this.salvarStateFiltros({
        filtroAplicado: this.filtroAplicado,
        paginaAtual,
        porPagina,
      });
      let parametros = {
        page: paginaAtual,
        amountPerPage: porPagina,
        ...helpers.formattingParameters(this.filtroAplicado),
      };

      OrdemServicoService.listarOrdemServicoPrevisaoEntrega(
        this.id,
        parametros
      ).then((res) => {
        this.tabela.selecionados = [];
        this.tabela.dados = res.data.items;

        this.tabela.quantidadeItens = res.data.totalItems;
        this.tabela.quantidadePaginas = res.data.totalPages;
        this.tabela.paginaAtual = paginaAtual;
        this.tabela.porPagina = porPagina;
      });
    },
    salvarStateFiltros(dados) {
      this.$store.dispatch('Filtros/adicionarFiltro', {
        rota: this.$route.name,
        dados,
      });
    },
  },
};
</script>
